export enum SwimSpotEditStatus{
    UNKNOWN,
    SUGGESTION,
    APPROVED,
    REJECTED
}